/**
 * DS Compare — Add-ons
 * ---------------------------------------------------------------
 * 1) Lifts the input controls into a full-width row above the two cards.
 * 2) Adds a "paste a product link" field under the dropdown.
 * 3) Auto-runs the verdict as soon as a product is chosen (no second click).
 * 4) Turns the verdict CTA into a real Add to Cart action.
 *
 * Verdict: the section's Analyze handler reads the competitor from a variable
 * inside its own closure, which it only sets when IT renders a card. Cards we
 * paint from a link are invisible to it. ds-compare-verdict.js renders the
 * verdict from the DOM instead; we call window.DSCMP_VERDICT().
 *
 * v5.4: product thumbnails reinstated. Link-loaded cards hand the Worker's
 * scraped image URL plus the page URL to window.DSCMP_IMAGE (see
 * ds-compare-image.js), which verifies each source in the browser and
 * falls back to a "Product image is unavailable." placeholder.
 *
 * DS Labs v1.1: shampoo-vs-shampoo only — link results that are not shampoos
 * are rejected with a notice. Claim language is appearance-based (cosmetic).
 */
(function () {
  var CTA_ID = 'dscmp-cta';
  var LABEL = 'ADD REVITA TO CART';
  var URL_PLACEHOLDER = 'Paste a shampoo product page link here to compare it to this one';
  var VS_LABEL = 'Your Product';
  var LOOKUP_TIMEOUT_MS = 45000;

  /* ======================= LAYOUT: full-width picker ======================= */

  var restructured = false;

  function restructure() {
    if (restructured) return;
    var grid = document.querySelector('.dscmp-grid');
    var vsCol = document.querySelector('.dscmp-col--vs');
    var tabs = document.querySelector('.dscmp-tabs');
    var inputs = document.querySelector('.dscmp-inputs');
    if (!grid || !vsCol || !inputs) return;
    restructured = true;

    var top = document.createElement('div');
    top.className = 'dscmp-toprow';

    var heading = document.createElement('p');
    heading.className = 'dscmp-label dscmp-toprow__label';
    heading.textContent = 'Compare With';
    top.appendChild(heading);

    if (tabs) top.appendChild(tabs);
    top.appendChild(inputs);

    grid.parentNode.insertBefore(top, grid);

    var vsLabel = vsCol.querySelector('.dscmp-label');
    if (vsLabel) vsLabel.textContent = VS_LABEL;
  }

  /* ==================== AUTO-RUN THE VERDICT ==================== */

  function runVerdict() {
    if (typeof window.DSCMP_VERDICT === 'function') window.DSCMP_VERDICT();
  }

  function styleAnalyze() {
    var btn = document.getElementById('dscmp-analyze');
    if (!btn || btn.dataset.dscmpBound === '1') return;
    btn.dataset.dscmpBound = '1';
    btn.classList.add('dscmp-analyze--auto');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      runVerdict();
    }, true);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'dscmp-select') return;
    if (!e.target.value) return;
    setTimeout(runVerdict, 90);
  }, true);

  /* The section's own photo flow paints a card without telling us — watch for it. */
  function watchCard() {
    var card = document.getElementById('dscmp-vscard');
    if (!card || card.dataset.dscmpVerdict === '1') return;
    card.dataset.dscmpVerdict = '1';
    new MutationObserver(function () {
      if (!card.classList.contains('is-empty')) setTimeout(runVerdict, 60);
    }).observe(card, { attributes: true, attributeFilter: ['class'] });
  }

  /* ============================ ADD TO CART ============================ */

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function relabelCta(cta) {
    if (!cta || cta.dataset.dscmpCart === '1') return;
    cta.dataset.dscmpCart = '1';
    cta.textContent = LABEL;
    cta.classList.add('dscmp-cta--cart');
  }

  function ctaState(cta, txt, busy) {
    cta.textContent = txt;
    cta.classList.toggle('is-busy', !!busy);
  }

  function addToCart(cta) {
    var form = productForm();
    if (!form) { window.location.href = window.location.pathname; return; }

    ctaState(cta, 'Adding…', true);

    var data = new FormData(form);
    if (!data.get('quantity')) data.set('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'failed'); });
        return r.json();
      })
      .then(function () {
        ctaState(cta, 'Added ✓', true);
        if (window.DSCMP_TRACK) window.DSCMP_TRACK('atc');
        // setTimeout(function () { window.location.href = '/cart'; }, 550);
        document.querySelector('.dscmp-modal .dscmp-modal__close')?.click();
      })
      .catch(function (err) {
        console.error('[dscmp] add to cart:', err);
        ctaState(cta, 'Couldn’t add — try again', false);
        setTimeout(function () { ctaState(cta, LABEL, false); }, 2600);
      });
  }

  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest && e.target.closest('#' + CTA_ID);
    if (!cta) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (cta.classList.contains('is-busy')) return;
    addToCart(cta);
  }, true);

  /* ========================== COMPARE BY LINK ========================== */

  var urlBuilt = false;

  function buildUrlField() {
    if (urlBuilt) return;
    var pane = document.querySelector('[data-dscmp-pane="select"]');
    if (!pane) return;
    urlBuilt = true;

    var wrap = document.createElement('div');
    wrap.className = 'dscmp-urlblock';
    wrap.innerHTML =
      '<div class="dscmp-or"><span>or</span></div>' +
      '<div class="dscmp-urlrow">' +
        '<input type="url" id="dscmp-url" class="dscmp-urlinput" ' +
          'placeholder="' + URL_PLACEHOLDER + '" autocomplete="off" spellcheck="false" ' +
          'aria-label="Product page link">' +
        '<button type="button" id="dscmp-urlgo" class="dscmp-urlgo">Compare</button>' +
      '</div>' +
      '<div class="dscmp-uploadstate dscmp-urlstate" id="dscmp-urlstate" hidden></div>';

    pane.appendChild(wrap);

    document.getElementById('dscmp-urlgo').addEventListener('click', submitUrl);
    document.getElementById('dscmp-url').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitUrl(); }
    });
  }

  function endpoint() {
    var el = document.getElementById('dscmp-config');
    if (!el) return '';
    try { return (JSON.parse(el.textContent || '{}').photoEndpoint || '').trim(); }
    catch (e) { return ''; }
  }

  function competitorNames() {
    var el = document.getElementById('dscmp-data');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]').map(function (d) {
        var n = d && d.name ? String(d.name) : '';
        var b = d && d.brand ? String(d.brand) : '';
        return b ? n + ' (' + b + ')' : n;
      });
    } catch (e) { return []; }
  }

  function setStatus(html, isError) {
    var s = document.getElementById('dscmp-urlstate');
    if (!s) return;
    if (!html) { s.hidden = true; s.innerHTML = ''; s.classList.remove('is-error'); return; }
    s.hidden = false;
    s.innerHTML = html;
    s.classList.toggle('is-error', !!isError);
  }

  function submitUrl() {
    var input = document.getElementById('dscmp-url');
    var btn = document.getElementById('dscmp-urlgo');
    if (!input || !btn || btn.disabled) return;

    var value = (input.value || '').trim();
    if (!value) { input.focus(); return; }
    if (!/^https?:\/\//i.test(value)) value = 'https://' + value;

    var ep = endpoint();
    if (!ep) { setStatus('Link comparison is not configured yet.', true); return; }

    btn.disabled = true;
    input.disabled = true;
    setStatus('<span class="dscmp-spinner"></span><span>Opening that page…</span>');

    var done = false;
    var timer = setTimeout(function () {
      if (done) return;
      done = true;
      setStatus('That page is taking too long to read. Try a photo of the product instead, or pick from the list.', true);
      btn.disabled = false;
      input.disabled = false;
    }, LOOKUP_TIMEOUT_MS);

    fetch(ep, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: value, competitors: competitorNames() })
    })
      .then(function (r) {
        return r.json().then(function (b) {
          if (!r.ok) throw new Error(b && b.error ? b.error : 'Request failed');
          return b;
        });
      })
      .then(function (res) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        setStatus('');
        applyResult(res, value);
      })
      .catch(function (err) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        setStatus(String(err.message || 'We couldn’t read that page. Try a photo instead.'), true);
      })
      .then(function () {
        btn.disabled = false;
        input.disabled = false;
      });
  }

  function applyResult(res, pageUrl) {
    if (!res || typeof res !== 'object') return;

    var sel = document.getElementById('dscmp-select');
    if (res.match !== null && res.match !== undefined && sel && sel.options[res.match + 1]) {
      sel.value = String(res.match);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var p = res.product || {};
    if (!p.name || /not a hair (loss|care) product/i.test(p.name)) {
      setStatus('That page doesn’t look like a hair-care product. Try another link, or a photo.', true);
      return;
    }
    if (!/shampoo/i.test(String(p.name || '') + ' ' + String(p.format || '') + ' ' + String(p.category || ''))) {
      setStatus('We compare shampoos with shampoos only. That looks like a topical treatment or another format — try a shampoo product page, or pick one from the list.', true);
      return;
    }
    paintCard(p, pageUrl);
    if (window.DSCMP_TRACK) window.DSCMP_TRACK('compare');
    setTimeout(runVerdict, 60);
  }

  function paintCard(p, pageUrl) {
    var card = document.getElementById('dscmp-vscard');
    if (!card) return;
    card.classList.remove('is-empty');

    if (window.DSCMP_IMAGE) {
      window.DSCMP_IMAGE({
        workerUrl: p.image || p.image_url || '',
        pageUrl: pageUrl || '',
        name: p.name || '',
        brand: p.brand || ''
      });
    }

    var awaiting = document.getElementById('dscmp-awaiting');
    if (awaiting) {
      awaiting.classList.remove('is-visible');
      awaiting.hidden = true;
    }

    var name = document.getElementById('dscmp-cname');
    if (name) name.innerHTML = escapeHtml(p.name) + ' <span class="dscmp-idtag">Identified from your link</span>';

    var map = { price: p.price, key_active: p.key_active, tech: '', sulfate: p.sulfate_free, format: p.format };
    card.querySelectorAll('[data-cspec]').forEach(function (el) {
      el.textContent = map[el.getAttribute('data-cspec')] || '—';
    });

    var benefits = document.getElementById('dscmp-c-benefits');
    if (benefits) benefits.innerHTML = benefitRows(p);

    var tally = document.getElementById('dscmp-c-tally');
    if (tally) tally.innerHTML = tallyFor(p);

    var themes = document.getElementById('dscmp-c-themes');
    if (themes) themes.innerHTML = '<li>No aggregate review data for this product.</li>';

    var rating = document.getElementById('dscmp-c-rating');
    if (rating) rating.innerHTML = '';

    var analyze = document.getElementById('dscmp-analyze');
    if (analyze) analyze.disabled = false;
  }

  function roles(p) {
    var out = [];
    var a = String(p.key_active || '');

    if (a && !/^(none|not stated)$/i.test(a)) {
      out.push({
        role: /caffeine|ketoconazole|biotin|niacinamide|peptide/i.test(a) ? 'ACTIVE' : 'SUPPORT',
        name: a,
        desc: /caffeine|ketoconazole|biotin|niacinamide|peptide/i.test(a)
          ? 'Density-support active listed for this product'
          : 'Primary ingredient listed for this product'
      });
    }

    if (/^no$/i.test(String(p.sulfate_free || ''))) {
      out.push({
        role: 'FILLER',
        name: 'Sulfate surfactant base',
        desc: 'Sulfate detergents — linked to dryness and breakage-prone strands; no density-support function'
      });
    }
    return out;
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  function benefitRows(p) {
    var items = roles(p);
    if (!items.length) {
      return '<li class="dscmp-ing dscmp-ing--filler"><span class="dscmp-dot dscmp-dot--filler">–</span>' +
        '<span class="dscmp-ing__body"><b>No actives found</b><span>We couldn’t find published density-support actives for this product.</span></span></li>';
    }
    return items.map(function (it) {
      var cls = it.role === 'ACTIVE' ? 'active' : (it.role === 'SUPPORT' ? 'support' : 'filler');
      var icon = it.role === 'ACTIVE' ? CHECK : (it.role === 'SUPPORT' ? '~' : '–');
      var tag = it.role === 'ACTIVE' ? 'Density-support active' : (it.role === 'SUPPORT' ? 'Supporting' : 'Filler');
      return '<li class="dscmp-ing dscmp-ing--' + cls + '">' +
        '<span class="dscmp-dot dscmp-dot--' + cls + '">' + icon + '</span>' +
        '<span class="dscmp-ing__body"><b>' + escapeHtml(it.name) + '<em>' + tag + '</em></b>' +
        '<span>' + escapeHtml(it.desc) + '</span></span></li>';
    }).join('');
  }

  function tallyFor(p) {
    var items = roles(p), a = 0, s = 0, f = 0;
    items.forEach(function (i) { if (i.role === 'ACTIVE') a++; else if (i.role === 'SUPPORT') s++; else f++; });
    if (!items.length) return '<span class="t-active">0 active</span>';
    var out = '<span class="t-active">' + a + ' active</span>';
    if (s) out += '<span class="t-support">' + s + ' supporting</span>';
    if (f) out += '<span class="t-filler">' + f + ' filler</span>';
    return out;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ============================== BOOT ============================== */

  var mo = new MutationObserver(function () {
    restructure();
    buildUrlField();
    styleAnalyze();
    watchCard();
    relabelCta(document.getElementById(CTA_ID));
  });

  function start() {
    restructure();
    buildUrlField();
    styleAnalyze();
    watchCard();
    relabelCta(document.getElementById(CTA_ID));
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
